/* eslint-disable no-undef */
import development from './development.config';
import production from './production.config';

export default !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
  ? development
  : production;
